export const PENDING_ACTIVATION = "PENDING";
